<template>
  <hic-list-page :title="meta.isIp ? '住院记录' : '门诊记录'" :entities="entities" :condition="condition" @load="page"
    keyword-placeholder="患者姓名或就诊号" :loading="meta.searching || meta.syncing">
    <template slot="title">
      <span>{{ meta.isIp ? "住院" : "门诊" }}记录<el-button type="text" @click="switchIO" size="small"
          icon="el-icon-sort" />：</span>
      <el-button v-if="setting.needSync && !meta.isIp && permission.emr_mr_sync" type="primary" @click="opSync"
        size="small" icon="el-icon-refresh" :loading="meta.syncing">数据同步</el-button>
      <el-button v-if="setting.needSync && !meta.isIp" type="info" @click="openPerCheck" size="small"
        icon="el-icon-camera">预检分诊</el-button>
    </template>

    <template slot="search">
      <el-checkbox v-model="meta.onlyMine" label="我的" class="left-pad" @change="onlyMineChange" />
      <hic-dict-selector v-if="meta.isIp" v-model="condition.wardCode" dict-type="IpWard" placeholder="病区"
        class="condition-input right-pad" size="small" @change="page"></hic-dict-selector>
      <el-date-picker v-if="!meta.isIp" v-model="condition.date" type="date" placeholder="就诊日期" size="small"
        style="width: 8rem" value-format="yyyy-MM-dd" class="left-pad" @change="page" />
      <el-date-picker v-else v-model="condition.startDate" type="date" placeholder="入院日期" size="small"
        style="width: 8rem" value-format="yyyy-MM-dd" class="left-pad" @change="page" />
      <hic-staff-selector v-if="!meta.onlyMine" v-model="condition.doctorCode" :name.sync="condition.doctorName"
        @change="staffChange" class="left-pad" style="width: 8rem" filterable clearable placeholder="医生姓名"
        :dept="user.deptCode" />
    </template>

    <el-table-column label="操作" width="100" align="center" key="action">
      <template slot-scope="{ row }">
        <el-button v-if="permission.emr_mr_edit && !row.mrMain" type="primary" icon="el-icon-edit-outline" circle
          size="mini" @click="generate(row)" title="新建" />
        <el-button v-if="permission.emr_mr_edit && row.mrMain" :disabled="row.mrMain.ifArchived" type="primary"
          icon="el-icon-edit" circle plain size="mini" @click="edit(row)" title="编辑" />
        <el-button :disabled="!row.mrMain" type="primary" icon="el-icon-search" circle plain size="mini"
          @click="edit(row, true)" title="预览" />
      </template>
    </el-table-column>
    <el-table-column type="expand" width="15" key="expand">
      <template slot-scope="{ row }">
        <el-alert v-if="!row.mrMain" type="warning" center show-icon :closable="false"
          title="病历尚未生成，请点击编辑按钮！"></el-alert>
        <el-descriptions v-if="row.mrMain" :column="2" class="left-pad">
          <el-descriptions-item label="主要诊断">{{ row.diagnosis }}</el-descriptions-item>
          <el-descriptions-item label="病历状态">
            <el-row type="flex" justify="space-between" align="middle">
              <el-tag v-if="row.mrMain.ifArchived" type="warning" size="mini" hit>已归档</el-tag>
              <el-tag v-else-if="row.mrMain.qcState == '通过'" type="success" size="mini" hit>通过</el-tag>
              <el-tag v-else-if="row.mrMain.qcState == '不通过'" type="danger" size="mini" hit>错误</el-tag>
              <el-tag v-else-if="row.mrMain.qcState == '待质控'" type="primary" size="mini" hit>提交</el-tag>
              <el-tag v-else-if="row.mrMain.qcState == '未提交'" type="info" size="mini" hit>草稿</el-tag>
              <el-button v-if="row.mrMain.qcState != '未提交'" icon="el-icon-s-promotion" type="text" round
                class="left-pad warning" size="mini" @click="send(row)">整理</el-button>
            </el-row>
          </el-descriptions-item>
          <el-descriptions-item label="最后编辑">
            <span>{{ row.mrMain.submitUserName }}</span>
            <small class="left-pad">{{ row.mrMain.submitTime | fmtDate }}</small>
          </el-descriptions-item>
          <el-descriptions-item label="锁定医师">
            <el-tag v-if="row.mrMain.editingUserName" type="danger" size="mini" hit>{{ row.mrMain.editingUserName
            }}</el-tag>
            <span v-if="permission.emr_mr_forcelock">
              <el-popconfirm v-if="row.mrMain.editingUserCode" title="确定要强行解锁病历吗？如果锁定医师正在编辑，可能会产生不可预料的后果！"
                @confirm="forceLock(row, false)">
                <el-button slot="reference" icon="el-icon-unlock" type="text" class="left-pad danger" round
                  size="mini">解锁</el-button>
              </el-popconfirm>
              <el-popconfirm v-else title="确定要对病历加锁吗？加锁后其他人将无法编辑此病历！" @confirm="forceLock(row, true)">
                <el-button slot="reference" icon="el-icon-lock" type="text" round class="success"
                  size="mini">加锁</el-button>
              </el-popconfirm>
            </span>
          </el-descriptions-item>
          <el-descriptions-item v-if="JSON.parse(row.mrMain.nos).length > 1" label="连续病历" :span="2">
            <el-tag v-for="n in JSON.parse(row.mrMain.nos)" :key="n" size="mini" type="info" class="left-pad"
              effect="dark">{{ n }}</el-tag>
          </el-descriptions-item>
        </el-descriptions>
      </template>
    </el-table-column>
    <el-table-column v-if="meta.isIp" label="住院号" prop="ipNo" align="left" sortable="custom" key="ipNo">
      <template slot-scope="{ row }">
        <el-link type="primary" @click="viewer(row)" icon="el-icon-house">
          {{ row.ipNo }}
        </el-link>
      </template>
    </el-table-column>
    <el-table-column v-else label="门诊号" prop="opNo" align="left" sortable="custom" key="opNo" width="160">
      <template slot-scope="{ row }">
        <el-link type="primary" @click="viewer(row)" icon="el-icon-collection-tag">
          {{ row.opNo }}
        </el-link>
      </template>
    </el-table-column>
    <el-table-column v-if="meta.isIp" label="床位" prop="bedNo" align="center" width="80" sortable="custom" key="bedNo">
      <template slot-scope="{ row }">
        <span class="sub-title">{{ row.bedNo }}</span>
      </template>
    </el-table-column>
    <el-table-column label="患者" prop="patientName" align="left" sortable="custom" key="patientName">
      <template slot-scope="{ row }">
        <span>{{ row.patientName }}</span>
      </template>
    </el-table-column>
    <el-table-column label="性别" prop="patientGender" align="center" width="80" sortable="custom" key="patientGender">
      <template slot-scope="{ row }">
        {{ row.patientGender | dictText("Gender") }}
      </template>
    </el-table-column>
    <el-table-column label="诊断" :prop="meta.isIp ? 'diagnosisName' : 'diagnosis'" align="left" sortable="custom"
      key="diagnosis" show-overflow-tooltip></el-table-column>
    <el-table-column v-if="meta.isIp" label="入院日期" prop="startDate" width="100" align="center" sortable="custom"
      key="startDate">
      <template slot-scope="{ row }">
        {{ row.startDate | fmtDate }}
      </template>
    </el-table-column>
    <el-table-column v-else label="就诊日期" prop="date" width="100" align="center" sortable="custom" key="date">
      <template slot-scope="{ row }">
        {{ row.date | fmtDate }}
      </template>
    </el-table-column>
    <el-table-column label="科室" prop="deptCode" align="center" sortable="custom" :filter-multiple="false"
      column-key="deptCode" key="deptCode">
      <template slot-scope="{ row }">
        {{ row.deptCode | dictText("Dept") }}
      </template>
    </el-table-column>
    <el-table-column label="首诊医生" prop="doctorName" align="center" sortable="custom" key="doctorName"></el-table-column>
    <el-table-column label="锁定医生" align="center" sortable="custom" key="lockerName">
      <template slot-scope="{ row }">
        <el-popconfirm v-if="row.mrMain && row.mrMain.editingUserCode" title="确定要强行解锁病历吗？如果锁定医师正在编辑，可能会产生不可预料的后果！"
          @confirm="forceLock(row, false)">
          <el-button slot="reference" type="text" class="danger" size="mini">{{ row.mrMain.editingUserName }} <i
              class="el-icon-unlock" /></el-button>
        </el-popconfirm>
      </template>
    </el-table-column>
    <el-table-column v-if="meta.isIp" label="状态" prop="state" align="center" sortable="custom" :filters="[
      { text: '在院', value: '已入住' },
      { text: '离院', value: '已离院' },
      { text: '出院', value: '已结算' },
    ]" :filtered-value="['已入住']" :filter-multiple="false" column-key="state" key="state">
      <template slot-scope="{ row }">
        <el-tag size="small" hit v-if="row.state == '已入住'" type="success">在院</el-tag>
        <el-tag size="small" hit v-if="row.state == '已离院'" type="danger">离院</el-tag>
        <el-tag size="small" hit v-if="row.state == '已结算'" type="danger" effect="plain">出院</el-tag>
      </template>
    </el-table-column>
    <!-- <el-table-column label="病历" prop="qcState" width="80" align="center" sortable="custom" key="qcState">
          <template slot-scope="{row}">
            <el-tag v-if="row.qcState=='通过'" type="success" size="mini" effect="plain">通过</el-tag>
            <el-tag v-if="row.qcState=='不通过'" type="danger" size="mini" effect="plain">错误</el-tag>
            <el-tag v-if="row.qcState=='待质控'" type="warning" size="mini" effect="plain">提交</el-tag>
            <el-tag v-if="row.qcState=='未提交'" type="info" size="mini" effect="plain">草稿</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="病历锁定" prop="editingUserCode" width="100" align="center" key="editingUserCode">
          <template slot-scope="{ row }">
            <el-tag v-if="row.editingUserCode" type="warning" size="mini"  hit>{{row.editingUserName}}</el-tag>
          </template>
        </el-table-column> -->
    <editor :visible.sync="meta.showEditor" :main="entity" :readonly="readonly" :condition="condition"
      :entities="entities" @entitySwitch="switchTreat" @paging="page" @refreshing="opSync" @saved="page" />
    <sender :visible.sync="meta.showSender" :main="meta.sendEntity" />
    <hic-emr-info-dialog :op-no="opNo" :visible.sync="meta.showViewer" />
  </hic-list-page>
</template>

<script>
import store from "@/common/store";
import { mapGetters } from "sw-hic";

export default {
  beforeRouteEnter(to, from, next) {
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
    if (!store.getters.permission.emr_mr_query) {
      next({
        name: "err",
        params: { err: cfg.errs.NeedPromission },
      });
    } else {
      next();
    }
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    this.meta.showEditor = false;
    next();
  },
  components: {
    editor: () => import("./dlgEditor"),
    sender: () => import("./dlgSender.vue"),
  },
  data() {
    return {
      meta: {
        searching: false,
        syncing: false,
        showEditor: false,
        showViewer: false,
        onlyMine: true,
        isIp: false,
        sendEntity: {},
        showSender: false,
      },
      entities: {},
      entity: {},
      opNo: null,
      options: [{ id: null, name: null }],
      condition: {
        deptCode: null,
        patientName: null,
        doctorName: null,
        keyword: null,
        sort: "id",
        asc: false,
        pageIndexOnView: 1,
        pageSize: 20,
        state: null,
        states: [],
      },
      readonly: false,
      actTab: "mr",
    };
  },
  computed: {
    ...mapGetters(["dict", "Enum", "permission", "user", "setting"]),
    isOp() {
      return this.actTab == "op";
    },
  },
  created() {
    if (this.setting.defaultIp) {
      this.meta.isIp = true;
    }

    if (!this.user.defaultImg) {
      this.$api.Oidc.getImg({ auCode: "hic", openId: this.user.id })
        .then((res) => {
          this.user.defaultImg = res;
          this.$store.commit("user", this.user);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  },
  methods: {
    async page() {
      if (this.meta.searching) {
        return;
      }
      // 只有同步时才使用医生姓名，查询时不使用
      this.condition.doctorName = null;
      if (this.meta.onlyMine) {
        this.condition.doctorCode = this.user.code;
      }

      this.meta.searching = true;
      try {
        this.condition.deptCode = this.user.deptCode;
        let entities;
        if (this.meta.isIp) {
          entities = await this.$api.Hospitalization.query(this.condition);
        } else {
          this.condition.state = null;
          this.condition.states = null;
          entities = await this.$api.Treatment.query(this.condition);
        }
        if (entities.items && entities.items.length) {
          let nos = entities.items.map((i) => i.opNo || i.ipNo);
          let con = {};
          if (this.meta.isIp) {
            con = { ipNos: nos };
          } else {
            con = { opNos: nos };
          }

          let mrMains = (await this.$api.MrMain.query(con)).items;
          if (mrMains && mrMains.length) {
            for (let item of entities.items) {
              let mrMain = mrMains.find((m) => m.opNo == (item.opNo || item.ipNo) || m.ipNo == (item.opNo || item.ipNo));
              // 如果因为之前的 bug 导致病历没有患者信息，则补上
              if (mrMain) {
                if (!mrMain.patientCode || !mrMain.patientName || !mrMain.deptCode) {
                  mrMain.patientCode = item.patientCode;
                  mrMain.patientName = item.patientName;
                  mrMain.patientGender = item.patientGender;
                  mrMain.patientAge = item.patientAge;
                  mrMain.deptCode = item.deptCode;
                  mrMain = await this.$api.MrMain.save(mrMain);
                }
                this.$set(item, "mrMain", mrMain);
              }

            }
          }
        }
        this.entities = entities;
      } catch (error) {
        console.log(error);
        // this.$message.error(error);
      } finally {
        this.meta.searching = false;
      }
    },
    // del(row) {
    //   let _this = this;
    //   if (row?.vers?.length) {
    //     return;
    //   } else {
    //     this.$api.MrVer.query({ mainId: row.id }).then((res) => {
    //       if (res?.items?.length) {
    //         row.vers = res.items;
    //         _this.$message.warning("当前病历无法删除，因为存在未删除的版本数据！");
    //       } else {
    //         _this
    //           .$confirm("确定要删除当前病历吗？")
    //           .then((res) => {
    //             this.$api.Mr.del(row.id).then((res) => {
    //               _this.entities.items.splice(this.entities.items.indexOf(row));
    //             });
    //           })
    //           .catch((err) => {});
    //       }
    //     });
    //   }
    // },
    async edit(row, readonly) {
      if (!row.mrMain) {
        return this.$message.warning("未找到对应的病历数据！");
      }
      this.readonly = readonly;
      this.entity = row.mrMain;
      this.meta.showEditor = true;
    },
    async generate(row) {
      try {
        let mains = (await this.$api.MrMain.query({ nos: row.opNo || row.ipNo })).items;
        let main;
        if (!mains[0]) {
          main = await this.$api.MrMain.save({
            opNo: row.opNo,
            ipNo: row.ipNo,
            patientCode: row.patientCode,
            patientName: row.patientName,
            patientGender: row.patientGender,
            patientAge: row.patientAge,
            deptCode: row.deptCode,
            deptName: row.deptName,
            doctorCode: row.doctorCode,
            doctorName: row.doctorName,
            diagnosis: row.diagnosis,
            opTime: this.$utils.Fmt.datetime(row.date || row.startDate),
            submitTime: this.$utils.Dt.now(),
            submitUserCode: this.user.code,
            submitUserName: this.user.name,
            qcState: this.Enum.MrQCState.待质控,
            nos: JSON.stringify([row.opNo || row.ipNo]),
            ifArchived: false,
            editingUserCode: this.user.code,
            editingUserName: this.user.name,
          });
        } else {
          main = mains[0];
        }

        this.$set(row, "mrMain", main);
        this.edit(row);
      } catch (err) {
        this.$message.error("病历生成失败！");
        console.log(err);
      }
    },
    // delVer(row) {
    //   this.$api.MrVer.del(row.id).then((res) => {
    //     let item = this.entities.items.find((item) => item.id == row.mainId);
    //     if (item) {
    //       item.vers.splice(item.vers.indexOf(row), 1);
    //       item.editingVerId = null;
    //     }
    //   });
    // },
    async opSync() {
      try {
        this.meta.syncing = true;
        let para = {
          takingDate: this.condition.date,
          deptName: this.$utils.Dict.text(this.user.deptCode, "Dept"),
          deptCode: this.user.deptCode,
          doctorName: null,
        };

        if (!para.takingDate) {
          console.log("输出时间");
          para.takingDate = this.$utils.Dt.today();
        }
        // if (this.condition.deptCode) {
        //   para.deptCode = this.condition.deptCode;
        // }
        // 只有同步时才使用医生姓名，查询时不使用
        if (this.condition.doctorCode) {
          para.doctorName = this.condition.doctorName;
        }

        let msg = await this.$api.Treatment.sync(para);
        this.$notify({
          title: "数据同步结果",
          message: msg,
          type: "warning",
          duration: 0,
        });

        this.condition.pageIndexOnView = 1;
        this.page();
      } catch (err) {
        // console.log(err)
        this.$message.error(err);
      } finally {
        this.meta.syncing = false;
      }
    },
    switchTreat(treat) {
      if (!treat) {
        // 表示一个病历提交了，清空这个病历的展示
        this.entity = {};
        return;
      }
      if (this.readonly) {
        this.edit(treat, true);
      } else {
        if (!treat.maMain) {
          this.generate(treat);
        } else {
          this.edit(treat);
        }
      }
    },
    viewer(row) {
      window.open(`/#/viewer?op=${row.opNo || row.ipNo}`);
      // this.opNo = row.opNo
      // this.meta.showViewer = true
    },
    openPerCheck() {
      window.open(this.$cfg.regUrl);
    },
    forceLock(row, yes) {
      if (!row.mrMain) {
        return;
      }
      this.$api.MrMain[yes ? "forceLock" : "forceUnlock"](row.mrMain.id).then((res) => {
        this.$set(row.mrMain, "editingUserCode", res.editingUserCode);
        this.$set(row.mrMain, "editingUserName", res.editingUserName);
      });
    },
    switchIO() {
      this.meta.isIp = !this.meta.isIp;
      if (this.meta.isIp) {
        this.condition.states = ["已入住", "已离院", "已结算"];
        this.condition.state = "已入住";
      } else {
        this.condition.states = [];
        this.condition.state = null;
      }
      this.condition.pageIndexOnView = 1;
      this.page();
    },
    send(row) {
      if (!row.mrMain) {
        return this.$message.warning("未找到对应的病历数据！");
      }
      this.meta.sendEntity = row.mrMain;
      this.meta.showSender = true;
    },
    onlyMineChange(val) {
      if (!val) {
        this.condition.doctorCode = null;
      } else {
        if (this.condition.doctorCode == this.user.code) {
          return;
        }
      }
      this.condition.pageIndexOnView = 1;
      this.page();
    },
    staffChange() {
      this.condition.pageIndexOnView = 1;
      this.page();
    },
  },
};
</script>
